import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
//possible enhancements at https://cloud.tencent.com/developer/article/1383557
export function linkifyHrefInText(textMsg) {
  var urlMatch = new RegExp(/[https?|ftp|file]+:\/\/[A-Za-z0-9+&@#/%?=~_\-|!:,.;]+[\-A-Za-z0-9+&@#/%=~_|]/);
  var matches = urlMatch.exec(textMsg);

  if (matches && (matches === null || matches === void 0 ? void 0 : matches.length) > 0) {
    var url = matches[0];
    textMsg = textMsg.replace(url, "<a target='_blank' href='" + url + "'>" + url + "</a>");
  }

  return textMsg;
}
export function qqKeFuHref(qq, name) {
  return "<a target='_blank' href='http://wpa.qq.com/msgrd?v=3&uin=" + qq + "&site=qq&menu=yes'>" + name + "</a>";
}